export default __webpack_public_path__ + "static/media/brand-hero-shape.ec92b75e.svg";